import type {
  ExpressionFilterSpecification,
  FilterSpecification,
} from "maplibre-gl";
import { $filters } from "./stores/filters";
import type { Apartment } from "./types";

export class Filters {
  *#soldOnFilterSpecification(): Generator<ExpressionFilterSpecification> {
    const filters = $filters.get();
    if (filters.soldOn.min !== undefined) {
      yield [">=", "sold_on", filters.soldOn.min.toJSON()];
    }
    if (filters.soldOn.max !== undefined) {
      yield ["<=", "sold_on", filters.soldOn.max.toJSON()];
    }
  }

  get specification(): FilterSpecification | undefined {
    return ["all", ...this.#soldOnFilterSpecification()];
  }

  filterApartment(apartment: Apartment): boolean {
    const filters = $filters.get();
    if (
      filters.soldOn.min !== undefined &&
      apartment.sold_on < filters.soldOn.min.toJSON()
    ) {
      return false;
    }
    if (
      filters.soldOn.max !== undefined &&
      apartment.sold_on > filters.soldOn.max.toJSON()
    ) {
      return false;
    }
    return true;
  }
}

export const filters = new Filters();
